module.exports = __webpack_public_path__ + "img/itx-text-paragraph.4fe3fbbb.svg";